import { useState, useCallback, danger, saveAs, addLogExport, downloadExcel } from "@";

// Hook for exporting data to Excel
export function useExport(
  fetchData,
  search,
  pageSize = null,
  headerCellsName = {},
  noPgn = false,
  splitDate = null,
  headerText = null,
  fileName = "data",
  logExport = {
    action: null,
    description: "",
  },
) {
  const [isExporting, setIsExporting] = useState(false);

  const exporting = useCallback(async () => {
    setIsExporting(true);
    try {
      const response = await fetchData(noPgn ? search : 1, pageSize, search);

      if (response.data) {
        const contentType = response.headers.get("Content-Type");
        if (
          !contentType ||
          !contentType.includes(
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          )
        ) {
          const exportData = response?.data?.data || response.data;
          await downloadExcel(
            exportData,
            headerCellsName,
            splitDate,
            headerText,
            fileName,
          );
        } else {
          const blob = new Blob([response.data]);
          saveAs(blob, `${fileName}.xlsx`);
        }
        await addLogExport(logExport?.action, logExport?.description);
      } else {
        await danger("لا توجد بيانات للتصدير");
      }
    } catch (error) {
      console.error(error);
      await danger("خطأ تصدير البيانات");
    } finally {
      setIsExporting(false);
    }
  }, [fetchData, search, pageSize, headerCellsName, noPgn, splitDate, headerText, logExport?.action, logExport?.description, fileName]);

  return { isExporting, exporting };
}
